import React, {PureComponent} from 'react';
import {
    AppLogo,
    ContextualBanner,
    HorizontalNavigation,
    Loader,
    NavigationMenuGroup,
    NavigationMenuItem,
    NavigationQuickActionGroup,
    Tag
} from "@hawkins/components";
import {IconHome} from "@hawkins/icons";
import Error404 from "./views/error-404";
import Home from "./views/home";
import {Link, Route, Routes} from "react-router-dom";
import {InitResponse} from "./api/types";
import {getMfaApplications, init} from "./api/mgmt";
import {MfaApplications} from "./util/mfa_applications";
import EditUserRoute from "./views/edit-user";

interface State {
  initResponse?: InitResponse;
  mfaApplications?: MfaApplications;
  error?: Error;
}

export default class App extends PureComponent<{}, {}> {
  state: State = {};

  componentDidMount() {
    this.refresh();
  }

  private refresh() {
    this.setState({initResponse: undefined, error: undefined});
    init({}).then((response) => {
      if (!response.authenticated) {
        window.location.href = '/meechum/mgmt';
        return;
      }
      if (!response.manager) {
          throw new Error("User is not authorized");
      }

      this.setState({initResponse: response});
      return getMfaApplications({}).then(res => {
        this.setState({mfaApplications: new MfaApplications(res.mfaApplications)});
      });
    }).catch((e: Error) => {
      this.setState({error: e});
    });
  }

  render() {
    return <div className="App">
      <header className="App-header">
        <HorizontalNavigation
            logo={<AppLogo name="Passwordless Enrollment Management" studioLogo/>}
            quickActions={
              <NavigationQuickActionGroup>
                {this.state.initResponse ? <Tag>{this.state.initResponse.userName}</Tag> : null}
              </NavigationQuickActionGroup>
            }
        >
          <NavigationMenuGroup>
            <Link style={{textDecoration: 'none'}} to="/"><NavigationMenuItem icon={IconHome}>Home</NavigationMenuItem></Link>
          </NavigationMenuGroup>
        </HorizontalNavigation>
      </header>

      {!this.state.error ? null : <ContextualBanner variant="error" title="Error" text={this.state.error.message} />}

      {!this.state.initResponse || !this.state.mfaApplications ? <Loader variant="linear" /> :
        <div id="container">
          <Routes>
            <Route path="/:domain/:userName" element={<EditUserRoute mfaApplications={this.state.mfaApplications}/>}/>
            <Route path="/" element={<Home mfaApplications={this.state.mfaApplications}/>}/>
            <Route path="*" element={<Error404/>}/>
          </Routes>
        </div>
      }
    </div>
  }
}
